module.exports = __webpack_public_path__ + "img/10.793ed2de.png";